module.exports = __webpack_public_path__ + "img/team_photo_1.44048b1c.png";